function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import logEvent from "../logEvent";
export var MESSAGE_REQUIRED_ERROR = "Message is required for js_unexpected.";
/**
 * Logs an event when JS logic ends in an unexpected state.
 *
 * @param {string} message Message to be logged.
 * @param {Object} [properties={}] Additional event properties.
 */ export default function logJsUnexpected(message) {
    var properties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!message) {
        throw Error(MESSAGE_REQUIRED_ERROR);
    }
    var body = {
        message: message
    };
    if (typeof properties === "string") {
        body.details = properties;
    } else {
        body = _object_spread({}, body, properties);
    }
    logEvent("js_unexpected", body);
}
